import { isEmpty } from 'lodash';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'data';
import { setDirtyState } from 'data/templates';
import { useRolesQuery, useRolesWithPlaceholderQuery } from 'queries/roles';
import { fetchProjectTemplate } from '../actions';
import { ProjectTemplate, ProjectTemplateStoreRecord } from '../types';
import { useActiveProjectTemplate } from './use-active-project-template';
import { useDynamicConditionFields } from './use-project-dynamic-template';

export const useProjectTemplate = (
  templateId: number,
): ProjectTemplateStoreRecord & { activeTemplate: ProjectTemplate } => {
  const dispatch = useDispatch();
  const projectTemplateStore = useSelector(
    (state: RootState) => state.templates.project.data[templateId],
  );

  const template = useActiveProjectTemplate();
  const { isFetched: isRolesFetched } = useRolesWithPlaceholderQuery();
  const { isLoading: isRolesLoading } = useRolesQuery();
  const dynamicConditionFields = useDynamicConditionFields();

  useEffect(() => {
    if (!isRolesFetched || isRolesLoading || isEmpty(dynamicConditionFields)) {
      return;
    }
    dispatch(
      setDirtyState({
        id: templateId,

        _state: false,
      }),
    );
    dispatch(
      fetchProjectTemplate({
        templateId,
        dynamicConditionFields,
      }),
    );
  }, [
    templateId,
    dispatch,
    isRolesFetched,
    isRolesLoading,
    dynamicConditionFields,
  ]);

  return { ...projectTemplateStore, activeTemplate: template };
};
